import { View } from "tamagui";
import { Loop } from "./Motion/Loop";
import { resolveShimmerStyle, type SkeletonDimension, type SkeletonRadius, type SkeletonShimmerProps } from "./SkeletonShimmer.shared";
export type { SkeletonDimension, SkeletonRadius, SkeletonShimmerProps } from "./SkeletonShimmer.shared";
export function SkeletonShimmer({
  width = "100%",
  height = "100%",
  radius = 8
}: SkeletonShimmerProps) {
  const {
    rest,
    highlight,
    restTransparent,
    radiusPx
  } = resolveShimmerStyle(radius);
  return <View width={width} height={height} borderRadius={radiusPx} overflow="hidden" style={{
    backgroundColor: rest
  }} data-sentry-element="View" data-sentry-component="SkeletonShimmer" data-sentry-source-file="SkeletonShimmer.tsx">
      <Loop kind="shimmer" style={{
      position: "absolute",
      inset: 0,
      backgroundImage: `linear-gradient(90deg, ${restTransparent} 0%, ${highlight} 50%, ${restTransparent} 100%)`
    }} data-sentry-element="Loop" data-sentry-source-file="SkeletonShimmer.tsx" />
    </View>;
}

// A shaped placeholder block (avatar, button, card region) — takes an explicit
// height and radius so skeletons can mirror real layouts. Prefer `$si` size
// tokens over raw px.
export const SkeletonBlock = ({
  width = "100%",
  height,
  radius = 8
}: {
  width?: SkeletonDimension;
  height: SkeletonDimension;
  radius?: SkeletonRadius;
}) => <SkeletonShimmer width={width} height={height} radius={radius} data-sentry-element="SkeletonShimmer" data-sentry-component="SkeletonBlock" data-sentry-source-file="SkeletonShimmer.tsx" />;